import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "./state/store";
import { SET_MATERIAL } from "./state/reducers/material";
import { Book } from "./types/material";
import { SET_SETTINGS, SetSettings } from "./state/reducers/settings";

// Ensures that we have material loaded. If we don't, display an app-level loading screen
interface Props {
  children: React.ReactElement;
}
export default function MaterialProvider(props: Props) {
  const dispatch = useAppDispatch();

  const settings = useAppSelector((state) => state.settings);
  const { material } = useAppSelector((state) => state.material);

  useEffect(() => {
    const loadMaterial = async () => {
      const data = require("./res/material.json");
      dispatch({
        type: SET_MATERIAL,
        payload: {
          material: data,
        },
      });
      const payloadResult: SetSettings = {
        type: SET_SETTINGS,
        payload: {
          ...settings,
        },
      };

      if (!settings.selectedChapters?.length) {
        const emptyChapterArray: boolean[][] = [];
        data.forEach((book: Book) => {
          emptyChapterArray.push(Array(book.chapters.length).fill(false));
        });
        payloadResult.payload.selectedChapters = emptyChapterArray;
      }
      if (!settings.myMaterial.length) {
        const defaultMaterial: boolean[][] = [];
        payloadResult.payload.selectedChapters.forEach((book, index) => {
          defaultMaterial.push([]);
          book.forEach((ch) => {
            defaultMaterial[index].push(!!ch);
          });
        });
        payloadResult.payload.myMaterial = defaultMaterial;
      }
      dispatch(payloadResult);
    };
    if (material.length === 0) loadMaterial();
  }, [material]);

  if (material.length === 0) {
    return <div>BQA Loading...</div>;
  }

  return props.children;
}
